// extracted by mini-css-extract-plugin
export var addButton = "_4w-d";
export var bullets = "_4w-e";
export var compact = "_4w-2";
export var container = "_4w-j";
export var extendedWarrantyModal = "_4w-f";
export var learn = "_4w-l";
export var learnMore = "_4w-g";
export var offeringOption = "_4w-3";
export var offeringPrice = "_4w-8";
export var offeringSubtitle = "_4w-7";
export var offeringTitle = "_4w-6";
export var offeringsContainer = "_4w-0";
export var pdpTilesBackground = "_4w-n";
export var plan = "_4w-m";
export var regular = "_4w-1";
export var remove = "_4w-k";
export var seeDetailsIcon = "_4w-i";
export var seeDetailsLink = "_4w-h";
export var selectedOption = "_4w-4";
export var shieldIcon = "_4w-b";
export var shieldIconCompact = "_4w-c";
export var subtitle = "_4w-a";
export var title = "_4w-9";
export var unselectedOption = "_4w-5";